module.exports = __webpack_public_path__ + "static/img/keep_member_bg_label.a56ae3cb.png";